import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, Text, Card, Heading, Grid, DataList, Button } from '@radix-ui/themes';
import UserAvatar from '../common/UserAvatar';
import GeneralInfoProfileForm from '../forms/GeneralInfoProfileForm';
import ProfilePictureForm from '../forms/ProfilePictureForm';

const GuardianProfile = () => {
    const user = useSelector((state) => state.user.details);
    const [isEditing, setIsEditing] = useState(false);

    return (
        <Box width="100%" maxWidth="1080px">
            <Grid columns="12" gap="4">
                <Box gridColumnStart="1" gridColumnEnd="13" gridRowStart="1">
                    <Card>
                        <Flex direction="column" gap="4">
                            <Flex direction="row" gap="4" align="center">
                                <ProfilePictureForm user={user} size="6" />
                                <Flex direction="column" gap="1">
                                    <Heading size="4">{user.firstname} {user.lastname}</Heading>
                                    <Text size="2" color="gray">{user.email ?? 'N/A'}</Text>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Card>
                </Box>

                <Box gridColumn="1 / span 6" gridRowStart="2">

                    <Card>
                        <Flex direction="row" justify="between" align="center">
                            <Heading size="4">General Information</Heading>
                            <Button onClick={() => setIsEditing(!isEditing)}>
                                {isEditing ? 'Cancel' : 'Edit'}
                            </Button>
                        </Flex>

                        {isEditing ? (
                            <GeneralInfoProfileForm onClose={() => setIsEditing(false)} setIsEditing={setIsEditing} />
                        ) : (
                            <DataList.Root>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Firstname</DataList.Label>
                                    <DataList.Value>{user.firstname}</DataList.Value>
                                </DataList.Item>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Lastname</DataList.Label>
                                    <DataList.Value>{user.lastname}</DataList.Value>
                                </DataList.Item>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Email</DataList.Label>
                                    <DataList.Value>{user.email ?? 'N/A'}</DataList.Value>
                                </DataList.Item>
                            </DataList.Root>
                        )}
                    </Card>
                </Box>

            </Grid>
        </Box>
    );
};

export default GuardianProfile;
